import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-speedtest', 'BrandSpeedtest', [["path",{"d":"M5.636 19.364a9 9 0 1 1 12.728 0"}],["path",{"d":"M16 9l-4 4"}]]);